(function(){
  function isSizeLegend(text){
    var t = (text || "").trim().toLowerCase();
    return (t === "beden" || t === "size" || t.indexOf("beden") === 0 || t.indexOf("size") === 0);
  }

  function setupSizeStrip() {
    document.querySelectorAll('fieldset.variant-option--default-width-buttons').forEach(function(fs){
      var legend = fs.querySelector(':scope > legend');
      if (!legend || !isSizeLegend(legend.textContent)) return;

      fs.classList.add('ea-size-fs');
      if (fs.querySelector(':scope > .ea-size-strip')) return;

      var labels = Array.from(fs.querySelectorAll(':scope > label.variant-option__button-label'));
      if (!labels.length) return;

      var strip = document.createElement('div');
      strip.className = 'ea-size-strip';
      labels.forEach(function(l){ strip.appendChild(l); });

      legend.insertAdjacentElement('afterend', strip);
    });
  }

  var productCache = null;
  var fetching = null;

  function getProductJson() {
    if (productCache) return Promise.resolve(productCache);
    if (fetching) return fetching;

    var url = location.pathname.replace(/\/$/, "") + ".js";
    fetching = fetch(url, { credentials: "same-origin" })
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(data){ productCache = data; return data; })
      .catch(function(){ return null; })
      .finally(function(){ fetching = null; });

    return fetching;
  }

  function getOptionValueFromVariant(v, optionIndex) {
    if (Array.isArray(v.options) && v.options[optionIndex] != null) return String(v.options[optionIndex]);
    var key = "option" + (optionIndex + 1);
    if (v[key] != null) return String(v[key]);
    return "";
  }

  function getVariantImageSrc(v) {
    // optional chaining kullanmadan (tema/derleyici kaynaklı syntax riskini sıfırlar)
    return (v && v.featured_image && v.featured_image.src) ||
           (v && v.featured_image) ||
           (v && v.image) ||
           (v && v.featured_media && v.featured_media.preview_image && v.featured_media.preview_image.src) ||
           "";
  }

  function applyColorThumbs() {
    var fieldset = document.querySelector('fieldset.variant-option--swatches');
    if (!fieldset) return;

    var optionIndex = Number(fieldset.getAttribute("data-fieldset-index") || 0);

    getProductJson().then(function(product){
      if (!product || !Array.isArray(product.variants)) return;

      var map = new Map();
      product.variants.forEach(function(v){
        var optVal = getOptionValueFromVariant(v, optionIndex);
        var src = getVariantImageSrc(v);
        if (optVal && src && !map.has(optVal)) map.set(optVal, src);
      });

      fieldset.querySelectorAll("label.variant-option__button-label").forEach(function(label){
        var input = label.querySelector('input[type="radio"]');
        if (!input) return;

        var val = input.value;
        var src = map.get(val);
        if (!src) return;

        var img = label.querySelector("img.variant-thumb");
        if (!img) {
          img = document.createElement("img");
          img.className = "variant-thumb";
          img.loading = "lazy";
          img.alt = val;
          img.decoding = "async";
          label.appendChild(img);
        }
        if (img.getAttribute("src") !== src) img.setAttribute("src", src);
      });
    });
  }

  function runAll(){
    setupSizeStrip();
    applyColorThumbs();
  }

  runAll();
  new MutationObserver(runAll).observe(document.documentElement, { childList: true, subtree: true });
})();

(function () {
  function ensureLightbox() {
    if (document.getElementById('eaLightbox')) return;

    var html = ''
      + '<div id="eaLightbox" aria-hidden="true" style="display:none;position:fixed;inset:0;z-index:999999;">'
      + '  <div id="eaLightboxBg" style="position:absolute;inset:0;background:rgba(0,0,0,.75);"></div>'
      + '  <button id="eaLightboxClose" aria-label="Kapat" style="position:absolute;top:16px;right:16px;width:44px;height:44px;border:0;border-radius:999px;background:#111;color:#fff;cursor:pointer;font-size:22px;line-height:44px;">×</button>'
      + '  <img id="eaLightboxImg" alt="" style="position:relative;max-width:92vw;max-height:92vh;top:50%;left:50%;transform:translate(-50%,-50%);object-fit:contain;background:#111;">'
      + '</div>';

    document.body.insertAdjacentHTML('beforeend', html);

    function close() {
      var box = document.getElementById('eaLightbox');
      box.style.display = 'none';
      box.setAttribute('aria-hidden', 'true');
      document.getElementById('eaLightboxImg').removeAttribute('src');
    }

    document.getElementById('eaLightboxBg').addEventListener('click', close);
    document.getElementById('eaLightboxClose').addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  }

  function pickBestSrc(img) {
    // currentSrc çoğu zaman en iyisi
    var best = img.currentSrc || img.getAttribute('src') || '';

    // srcset varsa en büyük width olanı seç
    var srcset = img.getAttribute('srcset');
    if (srcset) {
      var parts = srcset.split(',').map(function (p) { return p.trim(); }).filter(Boolean);
      var maxW = 0;
      parts.forEach(function (p) {
        var m = p.match(/\s+(\d+)w$/);
        var url = p.replace(/\s+\d+w$/, '').trim();
        if (m && url) {
          var w = parseInt(m[1], 10);
          if (w > maxW) { maxW = w; best = url; }
        }
      });
    }
    return best;
  }

  function openLightboxFromContainer(container) {
    if (!container) return;
    var img = container.querySelector('img.product-media__image') || container.querySelector('img');
    if (!img) return;

    var src = pickBestSrc(img);
    if (!src) return;

    ensureLightbox();
    var box = document.getElementById('eaLightbox');
    var lbImg = document.getElementById('eaLightboxImg');

    lbImg.src = src;
    lbImg.alt = img.getAttribute('alt') || '';
    box.style.display = 'block';
    box.setAttribute('aria-hidden', 'false');
  }

  function isGridGalleryClick(e) {
    // yalnızca grid galeride çalışsın
    return !!(e.target && e.target.closest && e.target.closest('media-gallery.media-gallery--grid'));
  }

  function onClickCapture(e) {
    if (!isGridGalleryClick(e)) return;

    // En yakın kartı bul
    var card = e.target.closest('li.product-media-container');
    if (!card) return;

    // Shopify'ın kendi lightbox/slider handler'ını ezmek için:
    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();

    openLightboxFromContainer(card);
  }

  function init() {
    // Capture phase: tema JS’inden önce yakalar
    document.addEventListener('click', onClickCapture, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
